import React from "react";
import moment from "moment";
import { EditAction } from "components/buttons";
import { useAuthDataContext, Restricted, permissions } from "components/auth";
import { DeleteActionWithModal } from "components/buttons";
import PropTypes from "prop-types";
import { injectIntl } from "react-intl";
import eventStatusTypes, { eventStatusTypesCopyable } from "../utils/event-status-types";
import {ActionButton} from "../../../components/buttons";
import {useDispatch} from "react-redux";
import {storeEventToCopyActionCreator} from "../../../actions/common-actions";

const hasRecordings = event => !event || (event && event.recordings && event.recordings.length > 0);
const isSportEvent = event => event && event.type && event.type.isSportEvent;
const isNotStarted = event => event && moment(event.startDate).isAfter(moment());
const isNotFinished = event =>
  event && moment(event.endDate).isAfter(moment()) && event.status !== eventStatusTypes.FINISHED;

const canCopyEvent = event => event && event.eventStatus && eventStatusTypesCopyable.includes(event.eventStatus);

const ActionButtons = ({ event, id, customerId, mutation, history, intl }) => {
  const dispatch = useDispatch();

  const { user, hasAdminPrivileges } = useAuthDataContext();

  const isDeleted = event && event.eventStatus === eventStatusTypes.DELETED;

  const handleRedirectToCopy = () => {
    dispatch(storeEventToCopyActionCreator(event));
    history.push(`/event/copy/${id}/customer/${customerId}`);
  }

  return (
    <>
      <Restricted permissions={[permissions.event_manage]}>
        {!isDeleted &&
          ((hasAdminPrivileges || isNotFinished(event) || isSportEvent(event)) && (
            <div>
              <EditAction url={`/event/edit/${id}/customer/${customerId}`} />
            </div>
          ))}

          {canCopyEvent(event) && (
              <ActionButton icon="file-copy" onClick={handleRedirectToCopy}/>
          )}


        {!isDeleted &&
          ((hasAdminPrivileges || isNotStarted(event)) && (
            <div>
              <DeleteActionWithModal
                disabledTooltipText={intl.formatMessage({ id: "app.event.delete.hasRecordings" })}
                disabled={hasRecordings(event)}
                actionButton
                urlOnSuccess="/event/list"
                history={history}
                mutation={mutation}
                mutationVariables={{ eventId: id, username: user.sub }}
                elementNameInResult="deleteEvent"
                elementToDelete={event ? event.title : ""}
                event={event}
              />
            </div>
          ))}
      </Restricted>
    </>
  );
};

ActionButtons.propTypes = {
  /**
   * Id del elemento sobre el que se realiza la acción
   **/
  id: PropTypes.string,
  /**
   * Id del customer
   **/
  customerId: PropTypes.string,
  /**
   * Evento
   **/
  event: PropTypes.object,
  /**
   * Función (options) => Promise que ejecuta el borrado del evento
   **/
  mutation: PropTypes.func,
};

export default injectIntl(ActionButtons);
